import type { ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for menu item style.
 *
 * @returns {ThemeStyle}
 */
export const getMuiMenuItemStyle = (): ThemeStyle => {
  return {
    root: {
      fontSize: 14,
      lineHeight: '16px',
      paddingTop: 0,
      paddingBottom: 0,
    },
  };
};
